import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ngc-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

    public readonly PAGE_NOT_FOUND_MESSAGE: string = 'Page not found';

    constructor() { }

    ngOnInit() {
    }
}
